export default "__VITE_ASSET__CXmeObfP__"